import { useContext, useEffect, useState } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import { currentDateForFile, firstDayMonth, todayDate, todayLastYear, YMD_FORMAT } from '../../utils/DateUtils';
import { AppContext } from '../../contexts/AppContext';
import moment from 'moment';
import ScrapsAPI from '../../services/ScrapsAPI';
import { decodeFileXLSX } from '../../utils/MiscellaneousUtils';

export const SORT = {
  UPWARD: 'upward',
  DOWNWARD: 'downward',
  NONE: '',
};

const useScrapsPresenter = tableRef => {
  const { idSupplier, userInfo } = useContext(LoginContext);
  const { showError, showWarning } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [contract, setContract] = useState('');
  const [supplierCode, setSupplierCode] = useState('');
  const [delivery, setDelivery] = useState('');
  const [rows, setRows] = useState([]);
  const [rowsToShow, setRowsToShow] = useState([]);
  const [rowsToShowSorted, setRowsToShowSorted] = useState([]);
  const [sort, setSort] = useState('');
  const [oldSearchRequest, setOldSearchRequest] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingExport, setLoadingExport] = useState(false);
  const [open, setOpen] = useState(false);
  const [dateFrom, setDateFrom] = useState(firstDayMonth());
  const [dateTo, setDateTo] = useState(moment());
  

  const isScrapper = userInfo.role.includes("CHATARRERO");

  useEffect(() => {
    search();
  }, []);

  useEffect(() => {
    setRowsToShow(rows);
    setRowsToShowSorted(rows);
  }, [rows]);

  const cleanFilters = () => {
    setSelectedSupplier(null);
    setDateFrom(null);
    setDateTo(null);
    setContract('');
    setSupplierCode('');
    setDelivery('');
  };

  const search = reload => {
    const request = reload
      ? oldSearchRequest
      : {
          cuit: isScrapper ? idSupplier : (selectedSupplier ? selectedSupplier.cuit : ''),
          startDate: dateFrom ? dateFrom.format(YMD_FORMAT) : undefined,
          endDate: dateTo ? dateTo.format(YMD_FORMAT) : undefined,
          supplierCode: !supplierCode.isBlank() ? supplierCode : '',         
          contract: !contract.isBlank() ? contract : '',
          delivery: !delivery.isBlank() ? delivery : ''
        };


    setOldSearchRequest(request);

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    ScrapsAPI.getScrapGrid(request)
      .then(res => setRows(res.data))
      .catch(error => showError('Error al obtener los registros'))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => search(true);

  
  const updateGrid = (reference, hasComment) => {
    const updatedRows = rows.clone();
    const rowIndex = updatedRows.findIndex(r => r.delivery === delivery);

    updatedRows[rowIndex].hasAcerBragComments = hasComment;

    setRows(updatedRows);
  };

  
  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[i++] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    if((errors[i++] = dateFrom && dateTo && dateTo.isBefore(dateFrom))){
      errorMessages.push('La Fecha hasta no puede ser menor a la Fecha desde');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  const handleExport = delivery => {
    setLoadingExport(true);
    const selectedAllRows = selectedRows.length === rows.length;

    const request = delivery && !selectedAllRows ? {
      ...oldSearchRequest,
      delivery: delivery?.join(',') || '',
      pageNumber: 0,
      pageSize: 0,
    } : oldSearchRequest;

    return ScrapsAPI.exportToExcel(request)
      .then(res => decodeFileXLSX(res, `Chatarra_${currentDateForFile()}.xlsx`))
      .catch(error => showError('No se pudo descargar el archivo solicitado'))
      .finally(() => setLoadingExport(false));
  };

  const sortByDate = (a, b, sort) => {
    const condition = sort === SORT.UPWARD;
    const elem = condition ? a : b;
    const comparison = condition ? b : a;

    return elem.deliveryDate.localeCompare(comparison.deliveryDate);

  };

  return {
    selectedSupplier,
    setSelectedSupplier,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    supplierCode,
    setSupplierCode,
    contract,
    setContract,
    delivery,
    setDelivery,
    validateAndSearch,
    cleanFilters,
    rows: sort !== SORT.NONE ? rowsToShowSorted.sort((a, b) => sortByDate(a, b, sort)) : rowsToShow,
    firstLoad,
    loading,
    gridFunctions: {
      disableSelectAll: 
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      cuit: oldSearchRequest.cuit,
      gridActions: {
        selectedSupplier,
        handleExport,
        loadingExport,
        sort,
        setSort,       
      },
    },
  };
};

export default useScrapsPresenter;